import {createSelector} from '@reduxjs/toolkit';
import {getSelectedItemTypes} from './item-types.js';
import {LABS_MAP} from '@src/constants';

export const getDateRanges = state => state.search.dateRanges;

export const getSearchGeometryGeoJson = state => state.search.geometry;
export const getGeometryZoomTo = state => state.search.geometryZoomTo;

// Get the loaded saved search id (null if not loaded)
export const getSearchId = state => state.search.id;

export const getSearchFilters = state => state.searchFilters;

export const getAccessPermissions = state =>
  state.searchFilters.accessPermissions;

export const filteredByDownloadAccess = state =>
  state && state.labs && state.labs[LABS_MAP.DOWNLOAD_FILTER];

// get array of item type id
export const getSearchItemTypeIds = createSelector(
  [getSelectedItemTypes],
  selectedItemTypes => Object.keys(selectedItemTypes),
);
export const getNoEndDate = state => state.search.noEndDate;
